import { useRouter } from "next/router";
export const EN_US_STANDARD_LOCALE = "en-US";
export const EN_CA_STANDARD_LOCALE = "en-CA";
export const FR_CA_STANDARD_LOCALE = "fr-CA";
/**
 * Returns the user's locale in standard format.
 *
 * @example
 * // en-CA
 * const locale = useLocaleStandard();
 */
export default function useLocaleStandard() {
  const { locale, defaultLocale = EN_US_STANDARD_LOCALE } = useRouter();
  const conversion = locale ? locale.split("-") : defaultLocale.split("-");
  return `${conversion[0]}-${conversion[1]?.toUpperCase()}`;
}
